import { george, pr, theme, helpers, AccountAPI } from "aaa";
import { ListItem } from "components/common/LandingPage";
import { NativeRaisedButton } from "components/common/NativeRaisedButton";
import { ui } from "components/util/uiHelpers";
import { observer } from "mobx-react";
import * as React from "react";
import externalInterfaceStore from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { PocketsRoutes } from "./PocketsRoutes";
import { PocketsStore } from "./PocketsStore";
import { FormattedHTMLMessage } from "react-intl";
import { InfoBoxWithBackground } from "components/common/InfoBoxWithBackground";
import { GenericAPIClient, AccountAPIClient } from "network/APIClient";
import { b64ToUint8, b64ToBlob } from "util/helpers";
import * as FileSaver from "file-saver";
import { GenericDocument } from "types/documents";
import authStore from "stores/AuthStore";

type IProps = {
    store: PocketsStore
};

export const PocketsLandingPage = observer(({ store }: IProps) => {
    if (store.isLoading) {
        return <george.LoadingIndicator isLoading height={ui.windowHeight} />;
    }

    const handleDownload = async (title: string) => {
        if (externalInterfaceStore.accountId) {
            try {
                const target = AccountAPI.getPocketsPreContractDocument(externalInterfaceStore.accountId, "de");
                const response = await AccountAPIClient.requestType(target);

                if (atob(response.content).slice(0, 1025).includes("%PDF-")) {
                    if (helpers.isAndroid() || helpers.isIos()) {
                        store.pdfData = b64ToUint8(response.content);
                        pushRoute(PocketsRoutes.PDF);
                    } else {
                        const blob = b64ToBlob(response.content, "application/pdf");
                        FileSaver.saveAs(blob, title);
                    }
                }
            } catch (error) {
                pushRoute("/error");
            }
        }
    };

    return (
        <george.LandingBackground useWebVersion>
            <div style={{ lineHeight: "24px" }}>
                <div style={{ padding: theme.MARGIN }}>
                    <pr.LandingPageTitle style={{ textAlign: "center" }}>
                        <FormattedHTMLMessage id="pockets.landingPage.title" />
                    </pr.LandingPageTitle>
                </div>
                <div style={{ padding: theme.MARGIN }}>
                    <pr.P_16_CONTENT>
                        <FormattedHTMLMessage id="pockets.landingPage.text" />
                    </pr.P_16_CONTENT>
                    <div
                        role="button"
                        onClick={() => handleDownload(ui.__("pockets.landingPage.document.title"))}
                        className="theme-secondary-action-label-color"
                        style={{
                            display: "flex",
                            alignItems: "center",
                            fontWeight: 600,
                            fontSize: 14,
                            cursor: "pointer",
                            marginTop: theme.MARGIN,
                        }}
                    >
                        <pr.IconDownload style={{ marginRight: 5 }} />
                        <span>{ui.__("pockets.landingPage.document.title")}</span>
                    </div>
                </div>
                <pr.LightSeparatorLine spacing={theme.MARGIN} />
                <div style={{ padding: theme.MARGIN, textAlign: "center" }}>
                    <NativeRaisedButton
                        className="theme-action-button-background-color"
                        style={{
                            height: 60,
                            boxShadow: "none",
                            borderRadius: theme.BORDER_RADIUS,
                        }}
                        fullWidth={externalInterfaceStore.isGeorgeApp}
                        primary
                        labelStyle={{ color: "white", fontSize: 16, fontWeight: 600, textTransform: "none" }}
                        label={ui.__("pockets.landingPage.next")}
                        onClick={() => {
                            pushRoute(PocketsRoutes.SUMMARY);
                        }}
                    />
                </div>
            </div>
        </george.LandingBackground>
    );
});


// WEBPACK FOOTER //
// ./src/components/pockets/PocketsLandingPage.tsx